import { isMobile as isMobileCore, parseQuery } from 'bog-arcade-core-ui/helpers';
import { isMobile } from 'pixi.js/dist/browser/pixi.mjs';

import { partnerService } from '../services/helperServices/PartnerService';
import { gameService } from '../services/apiServices/GameService';
import { RtlLanguages } from './constats';
import { GameApplicationType, GameMode } from './enums';
import { GAME_APPLICATION_TYPE_STATE, USER_DATA } from '../stateManagment';

export const init = () => {
  const query = parseQuery(window.location.search);
  const { playerexternalid, partnerid, lan, language, opentype, mode } = query;
  if (query.hasOwnProperty('partnerid')) {
    partnerService.partnerId = partnerid;
  }

  if (query.hasOwnProperty('language') || query.hasOwnProperty('lan')) {
    partnerService.language = lan || language;
  }

  if (playerexternalid) {
    USER_DATA.next({ id: playerexternalid });
  }
  gameService.mode = playerexternalid ? GameMode.real : GameMode.demo;

  if (
    (query.hasOwnProperty('opentype') && opentype === 'fun')
    ||
    (query.hasOwnProperty('mode') && mode === 'fun')
  ) {
    gameService.mode = GameMode.demo;
  }
  if (isMobile.phone || isMobile.tablet || isMobileCore()) {
    if (window.innerWidth > window.innerHeight) {
      document.documentElement.classList.add('is-landscape');
      GAME_APPLICATION_TYPE_STATE.next(GameApplicationType.landscape);
    } else {
      document.documentElement.classList.add('is-mobile');
      GAME_APPLICATION_TYPE_STATE.next(GameApplicationType.mobile);
    }
  } else {
    document.documentElement.classList.add('is-web');
    GAME_APPLICATION_TYPE_STATE.next(GameApplicationType.web);
    document.getElementById('big_root').style.display = 'none';
  }

  if (RtlLanguages.includes(partnerService.language)) {
    document.documentElement.setAttribute('data-dir', 'rtl');
  }
};
